import { isEmpty } from 'lodash'
import { ComponentType } from 'react'
import { GoCheck } from 'react-icons/go'
import { Col, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  ${up('sm')} {
    padding-top: 24px;
    padding-botton: 24px;
  }
`

const Title = styled.h4`
  font-size: 17px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 20px;

  ${up('sm')} {
    margin-bottom: 24px;
  }
`

const Section = styled.div`
  padding: 12px 0;

  ${up('sm')} {
    padding: 0;
  }
`

const SectionTitle = styled.h6`
  color: #0078c9;
  font-family: 600;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: 24px;
`

const Item = styled.div`
  display: flex;
  padding: 8px 0;
`

const ItemIcon = styled(GoCheck)`
  color: #0078c9;
  margin-top: 3px;
  margin-right: 10px;
`

interface Props {
  property: any
}

export const Details: ComponentType<Props> = ({ property }) => {
  const hasAmenities = !!property.amenities && !isEmpty(property.amenities)
  const hasServices = !!property.services && !isEmpty(property.services)
  const hasFurnishings = !!property.furnishings && !isEmpty(property.furnishings)

  if (hasAmenities || hasServices || hasFurnishings) {
    return (
      <Wrapper>
        <Title>Detalles</Title>
        <Row>
          {hasAmenities && (
            <Col md={6}>
              <Section>
                <SectionTitle>Amenidades</SectionTitle>
                <Row>
                  {property.amenities.map((amenity: any) => (
                    <Col xs={6} md={12} key={amenity.uuid}>
                      <Item>
                        <ItemIcon /> {amenity.name}
                      </Item>
                    </Col>
                  ))}
                </Row>
              </Section>
            </Col>
          )}
          {hasServices && (
            <Col md={6}>
              <Section>
                <SectionTitle>Servicios</SectionTitle>
                <Row>
                  {property.services.map((service: any) => (
                    <Col xs={6} md={12} key={service.uuid}>
                      <Item>
                        <ItemIcon /> {service.name}
                      </Item>
                    </Col>
                  ))}
                </Row>
              </Section>
            </Col>
          )}
          {hasFurnishings && (
            <Col md={6}>
              <Section>
                <SectionTitle>Equipamiento</SectionTitle>
                <Row>
                  {property.furnishings.map((furnishing: any) => (
                    <Col xs={6} md={12} key={furnishing.uuid}>
                      <Item>
                        <ItemIcon /> {furnishing.name}
                      </Item>
                    </Col>
                  ))}
                </Row>
              </Section>
            </Col>
          )}
        </Row>
      </Wrapper>
    )
  }

  return null
}
